import { Swiper, SwiperSlide } from 'swiper/react';
import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import * as T from './Slider.types';
import * as s from './Slider.css';
const Slider: FunctionComponent<T.ISliderProps> = (props) => {
    const { items, renderContent, swiperOptions, className, slideClassName, children, dataQaDetail, } = props;
    return (<div className={classNames(s.root, className)} data-qa-detail={dataQaDetail}>
      <Swiper {...swiperOptions}>
        {items.map((item, index) => {
            return (<SwiperSlide className={slideClassName} key={index}>
              {renderContent(item)}
            </SwiperSlide>);
        })}
        {children}
      </Swiper>
    </div>);
};
export default Slider;
